export default __webpack_public_path__ + "static/media/submit-button-on-click.e68bf3cf.png";